export const UPDATE_ITENS = 'UPDATE_ITENS';
export const UPDATE_ITENS_RAW = 'UPDATE_ITENS_RAW';
export const UPDATE_ITEM_BY_ID = 'UPDATE_ITEM_BY_ID';
export const UPDATE_FULLITEM_BY_ID = 'UPDATE_FULLITEM_BY_ID';
export const UPDATE_ITEM_CARAC_BY_ID = 'UPDATE_ITEM_CARAC_BY_ID';
export const DELETE_ITEM = 'DELETE_ITEM';
